/**
 * The labels (tunnisteet) a Kuutio instance can carry: a fixed vocabulary,
 * several per instance, at least one chosen when an instance is created
 * (#1209). The database CHECK in migration 317 keeps the same list; the
 * display shows each through t('instanceLabels.<label>').
 *
 * Copies: packages/shared/instanceLabels.js (the display imports it) and
 * apps/backend/src/shared/ (the backend cannot import packages/shared);
 * scripts/check-shared-copies.js keeps them identical.
 */
export const INSTANCE_LABELS = ['kuutio', 'demo', 'simulation', 'test', 'lab', 'event'];

export function isInstanceLabel(value) {
  return INSTANCE_LABELS.includes(value);
}

/** The valid, de-duplicated labels of `input`, or null when it is not a list of valid labels. */
export function normalizeInstanceLabels(input) {
  if (!Array.isArray(input)) return null;
  const out = [];
  for (const raw of input) {
    const label = String(raw || '').trim().toLowerCase();
    if (!isInstanceLabel(label)) return null;
    if (!out.includes(label)) out.push(label);
  }
  return out;
}
